import React from "react"
import { Box } from "@chakra-ui/react"
import { motion } from "framer-motion"

const loop = {
  projectionFloat: {
    initial: {
      y: 0,
    },
    animate: {
      y: [0, -4],
    },
    transition: {
      duration: 1.5,
      repeat: Infinity,
      repeatType: "reverse",
    },
  },

  projector1: {
    initial: {
      x: 0,
      y: 0,
      rotate: 0,
      scaleY: 1,
    },
    animate: {
      rotate: [0, 5],
      scaleY: [1, 1.1],
      x: [0, -20],
      y: [0, -30],
    },
    transition: {
      duration: 8,
      repeat: Infinity,
      repeatType: "reverse",
    },
  },

  projector2: {
    initial: {
      rotate: 0,
      x: 0,
      y: 0,
    },
    animate: {
      rotate: [0, -10],
      y: [0, 10],
      x: [0, 40],
    },
    transition: {
      delay: 1.5,
      duration: 8,
      repeat: Infinity,
      repeatType: "reverse",
    },
  },

  projector3: {
    initial: {
      rotate: 0,
      x: 0,
      y: 0,
    },
    animate: {
      rotate: [0, -10],
      x: [0, 20],
      y: [0, -25],
    },
    transition: {
      delay: 3,
      duration: 8,
      repeat: Infinity,
      repeatType: "reverse",
    },
  },

  exclamationPoint: {
    initial: {
      y: 0,
      scale: 0.85,
    },
    animate: {
      y: [0, -5],
      scale: [0.85, 1],
    },
    transition: {
      duration: 1.5,
      repeat: Infinity,
      repeatType: "reverse",
    },
  },

  cubeGlow: {
    initial: {
      opacity: 0.25,
    },
    animate: { opacity: [0.25, 0.5] },
    transition: {
      duration: 1.5,
      repeat: Infinity,
      repeatType: "reverse",
    },
  },
}

export function Controller(props) {
  return (
    <Box as="svg" viewBox="0 0 450 500" overflow="visible" {...props}>
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            "\n\t.st0{fill:#111C2C;}\n\t.st1{fill:#17253B;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#SVGID_2_);}\n\t.st4{fill:url(#SVGID_3_);}\n\t.st5{fill:url(#SVGID_4_);}\n\t.st6{fill:url(#SVGID_5_);}\n\t.st7{fill:url(#SVGID_6_);}\n\t.st8{fill:url(#SVGID_7_);}\n\t.st9{fill:url(#SVGID_8_);}\n\t.st10{fill:url(#SVGID_9_);}\n\t.st11{fill:url(#SVGID_10_);}\n\t.st12{fill:url(#SVGID_11_);}\n\t.st13{fill:url(#SVGID_12_);}\n\t.st14{opacity:0.25;fill:url(#SVGID_13_);enable-background:new    ;}\n\t.st15{opacity:0.33;fill:url(#SVGID_14_);enable-background:new    ;}\n\t.st16{fill:url(#SVGID_15_);}\n\t.st17{fill:#4700D4;stroke:#05B900;stroke-width:0.5422;stroke-miterlimit:10;}\n\t.st18{fill:url(#SVGID_16_);}\n\t.st19{fill:url(#SVGID_17_);}\n\t.st20{enable-background:new    ;}\n\t.st21{fill:#F4F4F4;}\n\t.st22{opacity:0.25;}\n\t.st23{fill:#4FC3F6;}\n\t.st24{fill:#E6E6E6;}\n\t.st25{fill:url(#SVGID_18_);}\n\t.st26{fill:url(#SVGID_19_);}\n\t.st27{fill:url(#SVGID_20_);}\n\t.st28{fill:url(#SVGID_21_);}\n\t.st29{fill:url(#SVGID_22_);}\n\t.st30{fill:url(#SVGID_23_);}\n\t.st31{opacity:0.5;}\n\t.st32{fill:url(#SVGID_24_);}\n\t.st33{fill:url(#SVGID_25_);}\n\t.st34{fill:url(#SVGID_26_);}\n\t.st35{fill:url(#SVGID_27_);}\n\t.st36{fill:url(#SVGID_28_);}\n\t.st37{fill:url(#SVGID_29_);}\n\t.st38{fill:url(#SVGID_30_);}\n\t.st39{fill:url(#SVGID_31_);}\n\t.st40{fill:url(#SVGID_32_);}\n\t.st41{fill:url(#SVGID_33_);}\n\t.st42{fill:url(#SVGID_34_);}\n\t.st43{fill:url(#SVGID_35_);}\n\t.st44{fill:url(#SVGID_36_);}\n\t.st45{fill:url(#SVGID_37_);}\n\t.st46{opacity:0.25;fill:url(#SVGID_38_);enable-background:new    ;}\n",
        }}
      />
      {/* BACKGROUND */}
      <rect fill="#111C2C" width={450} height={500} />

      <Projector1 />

      <Projector2 />

      <Projector3 />

      <EmailCube />
    </Box>
  )
}

const Projector1 = () => {
  return (
    <motion.g {...loop.projector1}>
      <path
        className="st1"
        d="M213.7,313.9c12,0.7,22.9,6.6,29.2,15c3.6,4.7,6.1,11.1,6,17.7c-0.1,6.5-2.6,12.4-6.7,17.1 c-6.7,7.7-17.8,12.3-29.8,11.7c-12.7-0.7-21.2-4.1-29.2-14.9c-3.9-5.2-6.1-11.3-5.9-17.8c0.1-6.7,3-12.7,6.7-17 C192.4,315.9,201.7,313.3,213.7,313.9z"
      />

      <radialGradient
        id="SVGID_1_"
        cx="-353.0404"
        cy="195.9817"
        r="21.2728"
        gradientTransform="matrix(-1.3762 -7.469741e-02 -2.602550e-02 1.1717 -267.6557 84.6984)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="5.000000e-02" style={{ stopColor: "#62C9F6" }} />
        <stop
          offset="0.5"
          style={{ stopColor: "#4AB6E6", stopOpacity: "0.8" }}
        />
        <stop
          offset="0.75"
          style={{ stopColor: "#4FC3F6", stopOpacity: "0.33" }}
        />
        <stop
          offset="0.97"
          style={{ stopColor: "#111C2C", stopOpacity: "0.3" }}
        />
        <stop offset={1} style={{ stopColor: "#4FC3F6" }} />
      </radialGradient>
      <path
        className="st2"
        d="M183.8,339.1c-0.3,13.6,12.6,25.4,28.8,26.3c16.2,0.9,29.6-9.5,29.9-23.1s-12.6-25.4-28.8-26.3
S184.1,325.5,183.8,339.1z"
      />
      <radialGradient
        id="SVGID_2_"
        cx="-353.0404"
        cy="195.9817"
        r="21.2728"
        gradientTransform="matrix(-1.3762 -7.469741e-02 -2.560241e-02 1.1527 -267.7386 88.4316)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="5.000000e-02" style={{ stopColor: "#62C9F6" }} />
        <stop
          offset="0.5"
          style={{ stopColor: "#4AB6E6", stopOpacity: "0.8" }}
        />
        <stop
          offset="0.75"
          style={{ stopColor: "#4FC3F6", stopOpacity: "0.33" }}
        />
        <stop offset={1} style={{ stopColor: "#111C2C", stopOpacity: "0.3" }} />
      </radialGradient>
      <path
        className="st3"
        d="M183.8,339.1c-0.3,13.6,12.6,25.4,28.8,26.3c16.2,0.9,29.6-9.5,29.9-23.1s-12.6-25.4-28.8-26.3
S184.1,325.5,183.8,339.1z"
      />
      <radialGradient
        id="SVGID_3_"
        cx="-353.0404"
        cy="195.7083"
        r="22.2692"
        gradientTransform="matrix(-1.3762 -7.469741e-02 -2.592192e-02 1.167 -267.6696 85.3236)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.9102" style={{ stopColor: "#62C9F6" }} />
        <stop offset="0.987" style={{ stopColor: "#111C2C" }} />
        <stop offset={1} style={{ stopColor: "#64B5F6", stopOpacity: "0.1" }} />
      </radialGradient>
      <path
        className="st4"
        d="M213.7,313.9c16.9,0.9,30.3,13.4,30,27.4c-0.3,14.2-14.3,25-31.2,24.1c16.2,0.9,29.6-9.5,29.9-23.1
c0.3-13.6-12.6-25.4-28.8-26.3c-16.2-0.9-29.6,9.5-29.9,23.1c-0.3,13.6,12.6,25.4,28.8,26.3c-16.9-0.9-30.3-13.2-30-27.4
C182.8,324,196.8,313,213.7,313.9z"
      />

      <path
        className="st1"
        d="M219.4,314.6l0.1-2.9l0.4,3l0,0C219.7,314.7,219.6,314.6,219.4,314.6z"
      />

      <path
        className="st1"
        d="M208,314l0.1-2.9l-0.5,2.9l0,0C207.7,314,207.8,314,208,314z"
      />

      <radialGradient
        id="SVGID_4_"
        cx="-353.1771"
        cy="188.56"
        r="12.5265"
        gradientTransform="matrix(-1.3762 -7.469741e-02 -2.355858e-02 1.0606 -267.9475 97.835)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.7949" style={{ stopColor: "#324F80" }} />
        <stop offset="0.9532" style={{ stopColor: "#17253B" }} />
      </radialGradient>
      <path
        className="st5"
        d="M213.7,313.9c-1.9-0.1-3.9-0.1-5.7,0.1l0.1-2.9c1.9-0.2,3.8-0.2,5.7-0.1c2,0.1,3.8,0.3,5.7,0.7l-0.1,2.9
C217.6,314.3,215.6,314,213.7,313.9z"
      />

      <radialGradient
        id="SVGID_5_"
        cx="-352.9388"
        cy="199.2316"
        r="15.684"
        gradientTransform="matrix(-1.3762 -7.469741e-02 -3.107942e-02 1.3992 -266.7247 42.7844)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.8507" style={{ stopColor: "#324F80" }} />
        <stop offset={1} style={{ stopColor: "#17253B" }} />
      </radialGradient>
      <path
        className="st6"
        d="M212.5,368.1c2,0.1,3.9,0.1,5.7-0.1l-0.1,2.3c-1.9,0.2-3.8,0.2-5.7,0.1c-2-0.1-3.8-0.3-5.7-0.7l0.1-2.3
C208.7,367.7,210.5,367.9,212.5,368.1z"
      />
      <linearGradient
        id="SVGID_6_"
        gradientUnits="userSpaceOnUse"
        x1="-379.4581"
        y1="189.0941"
        x2="-379.4581"
        y2="193.2869"
        gradientTransform="matrix(-1.209 -0.2587 7.311046e-02 2.0887 -260.5596 -124.199)"
      >
        <stop offset={0} style={{ stopColor: "#17253B" }} />
        <stop offset={1} style={{ stopColor: "#111C2C" }} />
      </linearGradient>
      <path
        className="st7"
        d="M205.8,376.3l0.9-6.7c1.9,0.4,3.7,0.6,5.7,0.7c2,0.1,3.8,0.1,5.7-0.1l0.6,6.8c-2.1,0-4.3,0-6.5-0.1
C210.1,376.7,208,376.5,205.8,376.3z"
      />
      <linearGradient
        id="SVGID_7_"
        gradientUnits="userSpaceOnUse"
        x1="-384.7239"
        y1="187.9818"
        x2="-384.7239"
        y2="192.2912"
        gradientTransform="matrix(-1.209 -0.2587 7.311046e-02 2.0887 -260.5596 -124.199)"
      >
        <stop offset={0} style={{ stopColor: "#17253B" }} />
        <stop offset={1} style={{ stopColor: "#111C2C" }} />
      </linearGradient>
      <polygon
        className="st8"
        points="218.2,370.2 218.2,367.9 218.8,375.3 218.8,377 		"
      />
      <linearGradient
        id="SVGID_8_"
        gradientUnits="userSpaceOnUse"
        x1="-374.6107"
        y1="188.862"
        x2="-374.6107"
        y2="193.2867"
        gradientTransform="matrix(-1.209 -0.2587 7.311046e-02 2.0887 -260.5596 -124.199)"
      >
        <stop offset={0} style={{ stopColor: "#17253B" }} />
        <stop offset={1} style={{ stopColor: "#111C2C" }} />
      </linearGradient>
      <polygon
        className="st9"
        points="206.7,369.6 206.8,367.3 205.9,374.6 205.9,376.3 		"
      />
      <path
        className="st0"
        d="M212.3,376.8c2.2,0.1,4.3,0.2,6.5,0.1l-0.3,13.6c-2.1,0-4.3,0-6.5-0.1c-2.2-0.1-4.3-0.3-6.5-0.6l0.3-13.6
C208,376.5,210.1,376.7,212.3,376.8z"
      />

      <polygon
        className="st0"
        points="181.5,343.1 177.6,348.3 177.4,360.9 175.8,360.8 176.1,347 179.7,343 		"
      />
      <radialGradient
        id="SVGID_9_"
        cx="-333.5612"
        cy="195.4959"
        r="5.0131"
        gradientTransform="matrix(-1.377 -2.479220e-02 -1.981938e-02 2.3836 -269.1117 -136.0929)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.7728" style={{ stopColor: "#324F80" }} />
        <stop offset={1} style={{ stopColor: "#17253B" }} />
      </radialGradient>
      <path
        className="st10"
        d="M179.9,333.1l1.8,0.1c-0.4,1.6-0.6,3.2-0.6,4.9c0,1.7,0.1,3.3,0.4,5l-1.8-0.1c-0.3-1.6-0.5-3.3-0.4-5
C179.3,336.3,179.5,334.7,179.9,333.1z"
      />
      <linearGradient
        id="SVGID_10_"
        gradientUnits="userSpaceOnUse"
        x1="-354.0291"
        y1="178.4593"
        x2="-350.6009"
        y2="178.8201"
        gradientTransform="matrix(-1.209 -0.2587 7.311046e-02 2.0887 -260.5596 -124.199)"
      >
        <stop offset={0} style={{ stopColor: "#17253B" }} />
        <stop offset={1} style={{ stopColor: "#111C2C" }} />
      </linearGradient>
      <path
        className="st11"
        d="M176.2,336l3.6-2.9c0,0,0,0.1-0.1,0.3c-0.3,1.5-0.5,3-0.6,4.6c0,1.7,0.1,3.3,0.4,5l-3.6,4.1
c0,0-0.4-4.2-0.3-7C175.8,337.2,176.2,336,176.2,336z"
      />

      <polygon
        className="st0"
        points="244.5,346.5 248.1,352.1 247.9,364.8 249.5,364.9 249.8,351 246.4,346.6 		"
      />
      <radialGradient
        id="SVGID_11_"
        cx="1006.4221"
        cy="195.4959"
        r="5.0131"
        gradientTransform="matrix(1.3748 0.1246 -8.598946e-02 2.38 -1126.8701 -249.5767)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.7728" style={{ stopColor: "#324F80" }} />
        <stop offset={1} style={{ stopColor: "#17253B" }} />
      </radialGradient>
      <path
        className="st12"
        d="M246.6,336.7l-1.8-0.1c0.3,1.6,0.5,3.3,0.4,5c0,1.7-0.3,3.3-0.6,4.9l1.8,0.1c0.4-1.6,0.6-3.2,0.6-4.9
C247,340,246.9,338.3,246.6,336.7z"
      />
      <linearGradient
        id="SVGID_12_"
        gradientUnits="userSpaceOnUse"
        x1="1042.7843"
        y1="173.1233"
        x2="1045.3942"
        y2="173.398"
        gradientTransform="matrix(1.209 0.2587 7.311046e-02 2.0887 -1026.9795 -288.1887)"
      >
        <stop offset={0} style={{ stopColor: "#17253B" }} />
        <stop offset={1} style={{ stopColor: "#111C2C" }} />
      </linearGradient>
      <path
        className="st13"
        d="M250.1,340l-3.5-3.3c0,0,0,0.1,0.1,0.3c0.3,1.5,0.4,3.1,0.4,4.7c0,1.7-0.3,3.3-0.6,4.9l3.4,4.4
c0,0,0.6-4.1,0.6-7C250.5,341.2,250.1,340,250.1,340z"
      />

      <linearGradient
        id="SVGID_13_"
        gradientUnits="userSpaceOnUse"
        x1="239.9494"
        y1="198.3777"
        x2="246.7578"
        y2="343.9709"
        gradientTransform="matrix(1 -4.593622e-03 4.593622e-03 1 -1.4785 1.3103)"
      >
        <stop
          offset="0.6154"
          style={{ stopColor: "#0D1824", stopOpacity: "0.1737" }}
        />
        <stop offset={1} style={{ stopColor: "#4FC3F5" }} />
        <stop offset={1} style={{ stopColor: "#4FC3F5" }} />
      </linearGradient>
      <path
        className="st14"
        d="M302.2,197.9l-59.8,144.4c-0.3,13.6-13.7,24-29.9,23.1c-16.2-0.9-29.1-12.6-28.8-26.3l2.5-139.7L302.2,197.9z
"
      />
    </motion.g>
  )
}

const Projector2 = () => {
  return (
    <motion.g {...loop.projector2}>
      <radialGradient
        id="SVGID_14_"
        cx="135.275"
        cy="352.0674"
        r="235.7138"
        gradientTransform="matrix(0.8897 0.4565 -0.4308 0.8396 166.603 -5.2887)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="3.312881e-02" style={{ stopColor: "#4FC3F5" }} />
        <stop
          offset="0.4614"
          style={{ stopColor: "#0D1824", stopOpacity: 0 }}
        />
      </radialGradient>
      <polygon
        className="st15"
        points="326.7,177.9 195.8,404.6 46,342.5 166,108.9 "
      />
      <radialGradient
        id="SVGID_15_"
        cx="67.6506"
        cy="504.5891"
        r="308.1824"
        gradientTransform="matrix(0.9253 0.3791 -0.1888 0.4607 100.294 246.4789)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.5" style={{ stopColor: "#111C2C" }} />
        <stop offset="0.9506" style={{ stopColor: "#0E1623" }} />
      </radialGradient>
      <path
        className="st16"
        d="M210.2,430.3l-5.6-6.8c-0.9-6.3-3.3-12.7-6.8-18.7c-9.6-16.7-28.1-33.5-52.5-46.2l0.8-5.3
c-4.7-2.5-9.6-4.7-14.7-6.9c-5.1-2.1-10.2-4-15.3-5.6l-3,4.1c-24.7-8.3-46.6-10.5-70-4.2c-6.7,1.8-12.9,4.6-18,8.4l-8.7,0.9
c0,0-1.9,1.5-3.8,6.1L2.1,381.8c-1.1,2.8-1.8,5.6-2.1,8.6v0l0,0l4.2,1.7c-1.8,26.6,29.2,60.3,75.5,79.4c46.2,19.2,92,17.3,109.5-2.8
l4.2,1.7l0,0c1.9-2.3,3.5-4.8,4.6-7.6l10.6-25.7C210.5,432.7,210.2,430.3,210.2,430.3z"
      />
      <linearGradient
        id="SVGID_22_"
        gradientUnits="userSpaceOnUse"
        x1="144.4316"
        y1="360.1831"
        x2="202.1898"
        y2="407.2601"
      >
        <stop
          offset="0.9"
          style={{ stopColor: "#4FC3F6", stopOpacity: "0.75" }}
        />
        <stop offset={1} style={{ stopColor: "#111C2C" }} />
      </linearGradient>
      <path
        className="st29"
        d="M145.2,361c25.3,13.3,44.5,30.7,54.5,48c1,1.7,1.9,3.4,2.7,5.1c-1.2-3.2-2.6-6.4-4.4-9.4
c-9.6-16.7-28.1-33.4-52.4-46.2L145.2,361z"
      />
      <linearGradient
        id="SVGID_21_"
        gradientUnits="userSpaceOnUse"
        x1="114.9552"
        y1="348.132"
        x2="146.2617"
        y2="348.132"
      >
        <stop offset={0} style={{ stopColor: "#4FC3F6", stopOpacity: "0.5" }} />
        <stop
          offset="0.5"
          style={{ stopColor: "#4FC3F6", stopOpacity: "0.75" }}
        />
        <stop offset={1} style={{ stopColor: "#4FC3F6", stopOpacity: "0.5" }} />
      </linearGradient>
      <path
        className="st28"
        d="M130.7,348.4c5.3,2.2,10.3,4.5,15.2,7.1l0.3-2.2c-4.7-2.5-9.6-4.7-14.7-6.9c-5.1-2.1-10.2-4-15.3-5.6l-1.3,1.8
C120.2,344.3,125.4,346.2,130.7,348.4z"
      />

      <linearGradient
        id="SVGID_23_"
        gradientUnits="userSpaceOnUse"
        x1="42.9126"
        y1="335.9414"
        x2="109.1104"
        y2="354.6667"
      >
        <stop offset={0} style={{ stopColor: "#111C2C" }} />
        <stop
          offset="0.1"
          style={{ stopColor: "#4FC3F6", stopOpacity: "0.75" }}
        />
      </linearGradient>
      <path
        className="st30"
        d="M33.3,344.4c1.9-0.7,3.8-1.3,5.7-1.8c24.3-6.5,47.1-4.2,72.7,4.4l1.5-2c0,0,0,0,0.1,0
c-24.7-8.3-46.6-10.5-70-4.2C38.2,342.1,33.3,344.4,33.3,344.4z"
      />
      <g className="st31">
        <linearGradient
          id="SVGID_24_"
          gradientUnits="userSpaceOnUse"
          x1="16.2115"
          y1="349.9168"
          x2="24.8967"
          y2="349.9168"
        >
          <stop offset={0} style={{ stopColor: "#111C2C" }} />
          <stop
            offset="0.3682"
            style={{ stopColor: "#4FC3F6", stopOpacity: "0.75" }}
          />
        </linearGradient>
        <path
          className="st32"
          d="M22.9,350.6c0.6-0.5,1.3-1,2-1.4l-8.4,0.8l-0.3,0.3L22.9,350.6z"
        />
      </g>
      <g className="st31">
        <linearGradient
          id="SVGID_25_"
          gradientUnits="userSpaceOnUse"
          x1="192.9612"
          y1="423.4661"
          x2="201.8173"
          y2="423.4661"
          gradientTransform="matrix(-0.7729 -0.6346 -0.6346 0.7729 628.7253 225.038)"
        >
          <stop offset={0} style={{ stopColor: "#111C2C" }} />
          <stop
            offset="0.3682"
            style={{ stopColor: "#4FC3F6", stopOpacity: "0.75" }}
          />
        </linearGradient>
        <polygon
          className="st33"
          points="204.7,425.2 204.7,423.5 210.2,430.3 210.2,430.7 	"
        />
      </g>
    </motion.g>
  )
}

const Projector3 = () => {
  return (
    <motion.g {...loop.projector3}>
      <path
        className="st1"
        d="M351.4,330.3c-21.3,13.3-37,31.3-42.9,47.2c-3.4,9-3.9,18.7,0.7,26c4.4,7.1,12.7,11.1,23.1,12.1
c17,1.6,39.9-4.8,61.2-18.2c22.4-14.1,35.5-26.8,43-47.2c3.6-9.8,3.7-19-0.8-26.1c-4.6-7.3-13.5-11-23.1-12
C391.1,310.2,372.7,317,351.4,330.3z"
      />
      <radialGradient
        id="SVGID_26_"
        cx="409.9748"
        cy="378.2683"
        r="61.0044"
        gradientTransform="matrix(0.8471 -0.5314 0.28 0.4464 -83.483 408.6039)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="5.000000e-02" style={{ stopColor: "#62C9F6" }} />
        <stop
          offset="0.5"
          style={{ stopColor: "#4AB6E6", stopOpacity: "0.8" }}
        />
        <stop
          offset="0.75"
          style={{ stopColor: "#4FC3F6", stopOpacity: "0.33" }}
        />
        <stop
          offset="0.97"
          style={{ stopColor: "#111C2C", stopOpacity: "0.3" }}
        />
        <stop offset={1} style={{ stopColor: "#4FC3F6" }} />
      </radialGradient>
      <path
        className="st34"
        d="M421.5,327.1c9.3,14.9-6.3,41.5-34.9,59.4c-28.6,17.9-59.4,20.4-68.7,5.5c-9.3-14.9,6.3-41.5,34.9-59.4
C381.4,314.7,412.2,312.2,421.5,327.1z"
      />
      <radialGradient
        id="SVGID_27_"
        cx="409.9748"
        cy="378.2683"
        r="61.0044"
        gradientTransform="matrix(0.8471 -0.5314 0.2755 0.4392 -81.7609 411.3492)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="5.000000e-02" style={{ stopColor: "#62C9F6" }} />
        <stop
          offset="0.5"
          style={{ stopColor: "#4AB6E6", stopOpacity: "0.8" }}
        />
        <stop
          offset="0.75"
          style={{ stopColor: "#4FC3F6", stopOpacity: "0.33" }}
        />
        <stop offset={1} style={{ stopColor: "#111C2C", stopOpacity: "0.3" }} />
      </radialGradient>
      <path
        className="st35"
        d="M421.5,327.1c9.3,14.9-6.3,41.5-34.9,59.4c-28.6,17.9-59.4,20.4-68.7,5.5c-9.3-14.9,6.3-41.5,34.9-59.4
C381.4,314.7,412.2,312.2,421.5,327.1z"
      />
      <radialGradient
        id="SVGID_28_"
        cx="409.9748"
        cy="377.4843"
        r="63.8619"
        gradientTransform="matrix(0.8471 -0.5314 0.2789 0.4446 -83.2593 408.9605)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.9102" style={{ stopColor: "#62C9F6" }} />
        <stop offset="0.987" style={{ stopColor: "#111C2C" }} />
        <stop offset={1} style={{ stopColor: "#64B5F6", stopOpacity: "0.1" }} />
      </radialGradient>
      <path
        className="st36"
        d="M351.4,330.3c-29.8,18.7-46,46.7-36.4,62c9.7,15.5,41.8,12.9,71.6-5.8c-28.6,17.9-59.4,20.4-68.7,5.5
c-9.3-14.9,6.3-41.5,34.9-59.4c28.5-17.9,59.4-20.4,68.7-5.5c9.3,14.9-6.3,41.5-34.9,59.4c29.8-18.7,46.1-46.5,36.4-62
C413.4,309.3,381.2,311.6,351.4,330.3z"
      />
      <g>
        <g>
          <path
            className="st1"
            d="M341.6,337.1l-2-3.2l1.2,3.7l0,0C341.1,337.5,341.3,337.3,341.6,337.1z"
          />
        </g>
      </g>
      <g>
        <path
          className="st1"
          d="M361.7,324.4l-2-3.2l2.8,2.7l0,0C362.3,324.1,362,324.3,361.7,324.4z"
        />
      </g>
      <radialGradient
        id="SVGID_29_"
        cx="409.5828"
        cy="356.985"
        r="35.9225"
        gradientTransform="matrix(0.8471 -0.5314 0.2535 0.4041 -79.357 415.1812)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.7949" style={{ stopColor: "#324F80" }} />
        <stop offset="0.9532" style={{ stopColor: "#17253B" }} />
      </radialGradient>
      <path
        className="st37"
        d="M351.4,330.3c3.4-2.2,6.9-4.1,10.4-5.9l-2-3.2c-3.5,1.8-6.9,3.7-10.4,5.9c-3.5,2.2-6.7,4.4-9.8,6.8l2,3.2
C344.7,334.7,347.9,332.5,351.4,330.3z"
      />
      <g>
        <radialGradient
          id="SVGID_30_"
          cx="410.2661"
          cy="387.588"
          r="44.9774"
          gradientTransform="matrix(0.8471 -0.5314 0.3344 0.5331 -102.2173 378.7391)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.8507" style={{ stopColor: "#324F80" }} />
          <stop offset={1} style={{ stopColor: "#17253B" }} />
        </radialGradient>
        <path
          className="st38"
          d="M388.5,389.5c-3.5,2.2-6.9,4.1-10.4,5.9l1.6,2.5c3.5-1.8,6.9-3.7,10.4-5.9c3.5-2.2,6.7-4.4,9.8-6.8l-1.6-2.5
C395.2,385.1,391.9,387.3,388.5,389.5z"
        />
        <linearGradient
          id="SVGID_31_"
          gradientUnits="userSpaceOnUse"
          x1="409.9748"
          y1="415.9544"
          x2="409.9748"
          y2="424.8778"
          gradientTransform="matrix(0.8471 -0.5314 0.5314 0.8471 -178.5676 257.0276)"
        >
          <stop offset={0} style={{ stopColor: "#17253B" }} />
          <stop offset={1} style={{ stopColor: "#111C2C" }} />
        </linearGradient>
        <path
          className="st39"
          d="M405.8,391.7l-5.9-6.5c-3.1,2.4-6.4,4.6-9.8,6.8c-3.5,2.2-6.9,4.1-10.4,5.9l3.3,8.2
c3.9-2.2,7.7-4.5,11.5-6.9S402.1,394.2,405.8,391.7z"
        />
        <linearGradient
          id="SVGID_32_"
          gradientUnits="userSpaceOnUse"
          x1="397.2876"
          y1="412.9945"
          x2="397.2876"
          y2="424.6156"
          gradientTransform="matrix(0.8471 -0.5314 0.5314 0.8471 -178.5676 257.0276)"
        >
          <stop offset={0} style={{ stopColor: "#17253B" }} />
          <stop offset={1} style={{ stopColor: "#111C2C" }} />
        </linearGradient>
        <polygon
          className="st40"
          points="379.7,397.9 378.1,395.3 381.8,404.1 383,406 		"
        />
        <linearGradient
          id="SVGID_33_"
          gradientUnits="userSpaceOnUse"
          x1="422.6566"
          y1="412.9945"
          x2="422.6566"
          y2="424.6156"
          gradientTransform="matrix(0.8471 -0.5314 0.5314 0.8471 -178.5676 257.0276)"
        >
          <stop offset={0} style={{ stopColor: "#17253B" }} />
          <stop offset={1} style={{ stopColor: "#111C2C" }} />
        </linearGradient>
        <polygon
          className="st41"
          points="399.9,385.2 398.3,382.7 404.6,389.8 405.8,391.7 		"
        />
      </g>
      <g>
        <polygon
          className="st0"
          points="428.2,329.1 438.5,330.9 447.2,344.8 450,343 440.5,327.9 431.4,327.1 		"
        />
        <radialGradient
          id="SVGID_34_"
          cx="465.8356"
          cy="376.8752"
          r="14.3762"
          gradientTransform="matrix(0.8588 -0.5123 0.5489 0.9202 -190.6115 220.5581)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.7728" style={{ stopColor: "#324F80" }} />
          <stop offset={1} style={{ stopColor: "#17253B" }} />
        </radialGradient>
        <path
          className="st42"
          d="M424.6,316.3l-3.2,2c1.7,1.4,3.2,3,4.3,4.8c1.2,1.8,2,3.8,2.5,6l3.2-2c-0.5-2.1-1.3-4.1-2.5-6
S426.3,317.7,424.6,316.3z"
        />
        <linearGradient
          id="SVGID_35_"
          gradientUnits="userSpaceOnUse"
          x1="478.6288"
          y1="379.4055"
          x2="486.0762"
          y2="380.1895"
          gradientTransform="matrix(0.8471 -0.5314 0.5314 0.8471 -178.5676 257.0276)"
        >
          <stop offset={0} style={{ stopColor: "#17253B" }} />
          <stop offset={1} style={{ stopColor: "#111C2C" }} />
        </linearGradient>
        <path
          className="st43"
          d="M433.1,315.7l-8.5,0.6c0,0,0.1,0.1,0.3,0.3c1.6,1.3,2.9,2.8,4,4.5c1.2,1.8,2,3.8,2.5,6l9.1,0.8
c0,0-2-5.1-4-8.2C434.6,316.6,433.1,315.7,433.1,315.7z"
        />
      </g>
      <g>
        <polygon
          className="st0"
          points="316.9,398.9 314,409 322.7,422.8 319.9,424.6 310.4,409.5 313.7,401 		"
        />
        <radialGradient
          id="SVGID_36_"
          cx="279.7693"
          cy="376.8752"
          r="14.3762"
          gradientTransform="matrix(-0.835 0.5503 0.5896 0.8947 333.0976 -103.0396)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.7728" style={{ stopColor: "#324F80" }} />
          <stop offset={1} style={{ stopColor: "#17253B" }} />
        </radialGradient>
        <path
          className="st44"
          d="M306.9,390.2l3.2-2c0.5,2.1,1.3,4.1,2.5,6s2.6,3.4,4.3,4.8l-3.2,2c-1.7-1.4-3.2-3-4.3-4.8
C308.2,394.3,307.4,392.3,306.9,390.2z"
        />
        <linearGradient
          id="SVGID_37_"
          gradientUnits="userSpaceOnUse"
          x1="292.5625"
          y1="379.4055"
          x2="300.0099"
          y2="380.1895"
          gradientTransform="matrix(-0.8471 0.5314 0.5314 0.8471 358.4322 -79.8354)"
        >
          <stop offset={0} style={{ stopColor: "#17253B" }} />
          <stop offset={1} style={{ stopColor: "#111C2C" }} />
        </linearGradient>
        <path
          className="st45"
          d="M302.7,397.5l4.2-7.4c0,0,0,0.2,0.1,0.4c0.5,2,1.3,3.9,2.4,5.6c1.2,1.8,2.6,3.4,4.3,4.8l-3.3,8.5
c0,0-3.7-4-5.6-7.1C302.8,399.3,302.7,397.5,302.7,397.5z"
        />
      </g>
      <linearGradient
        id="SVGID_38_"
        gradientUnits="userSpaceOnUse"
        x1="413.2945"
        y1="149.0479"
        x2="413.2945"
        y2="384.7114"
        gradientTransform="matrix(0.8471 -0.5314 0.5314 0.8471 -178.5676 257.0276)"
      >
        <stop
          offset="0.7317"
          style={{ stopColor: "#0D1824", stopOpacity: "0.1737" }}
        />
        <stop offset={1} style={{ stopColor: "#4FC3F5" }} />
      </linearGradient>
      <path
        className="st46"
        d="M186.5,197.4l131.4,194.7c9.3,14.9,40.1,12.4,68.7-5.5c28.6-17.9,44.2-44.6,34.9-59.4L302.7,110.3
L186.5,197.4z"
      />
    </motion.g>
  )
}

const EmailCube = () => {
  return (
    <motion.g {...loop.projectionFloat}>
      <linearGradient
        id="SVGID_16_"
        gradientUnits="userSpaceOnUse"
        x1="186.2333"
        y1="110.3385"
        x2="302.2383"
        y2="110.3385"
      >
        <stop offset={0} style={{ stopColor: "#4FC3F6", stopOpacity: "0.5" }} />
        <stop offset={1} style={{ stopColor: "#111C2C", stopOpacity: 0 }} />
      </linearGradient>
      <polygon
        className="st18"
        points="302.2,114 247.8,122.2 186.2,113.5 240.6,98.5 	"
      />

      <radialGradient
        id="SVGID_17_"
        cx="240.7232"
        cy="153.4532"
        r="204.0425"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.1" style={{ stopColor: "#4FC3F6", stopOpacity: 1 }} />
        <stop offset="0.5" style={{ stopColor: "#111C2C", stopOpacity: 0 }} />
      </radialGradient>
      <motion.path
        {...loop.cubeGlow}
        className="st19"
        d="M283.7,43.5l-87.4-1.2c-47.2,5.6-82.7,45.6-82.7,93V171c0,50,39.2,91.2,89.2,93.6L278,264
c50.2-2.1,89.8-43.4,89.8-93.6v-33.7C367.8,88.6,331.5,48.4,283.7,43.5z"
      />

      {/* Email icon */}
      <g>
        <polygon
          className="st21"
          points="268.3,136.1 245.4,152.8 222.6,130.3 				"
        />
        <polygon
          className="st21"
          points="268.2,142 268.2,175.2 222.6,169.4 222.6,136.2 245.4,158.6 				"
        />
      </g>

      <g className="st22">
        <path
          className="st23"
          d="M240.6,98.5l61.6,15.5v83.9l-54.4,7.4l-61.6-7.9v-83.9L240.6,98.5 M240.6,96.6l-0.5,0.1l-54.4,15l-1.4,0.4
v1.4v83.9v1.6l1.6,0.2l61.6,7.9l0.2,0l0.2,0l54.4-7.4l1.6-0.2v-1.6V114v-1.4l-1.4-0.4l-61.6-15.5L240.6,96.6L240.6,96.6z"
        />
      </g>

      {/* exlamation point */}
      <motion.path
        {...loop.exclamationPoint}
        fill="#E6E6E6"
        d="M246.1,85.8c-1.6,0-3-0.5-4.1-1.6c-1.1-1.1-1.7-2.3-1.7-3.8c0-1.5,0.5-2.7,1.7-3.8c1.1-1.1,2.5-1.6,4.1-1.6
c1.5,0,2.9,0.5,4,1.6c1.2,1.1,1.8,2.3,1.8,3.8c0,1-0.3,1.9-0.8,2.7c-0.5,0.8-1.2,1.5-2.1,2C248.1,85.5,247.1,85.8,246.1,85.8z
M251.5,38.9l-0.9,32.4h-8.9l-1-32.4H251.5z"
      />

      <g>
        <linearGradient
          id="SVGID_18_"
          gradientUnits="userSpaceOnUse"
          x1="186.2333"
          y1="197.6859"
          x2="302.2383"
          y2="197.6859"
        >
          <stop
            offset={0}
            style={{ stopColor: "#4FC3F6", stopOpacity: "0.5" }}
          />
          <stop offset={1} style={{ stopColor: "#111C2C", stopOpacity: 0 }} />
        </linearGradient>
        <polygon
          className="st25"
          points="302.2,197.9 247.8,205.3 186.2,197.4 240.6,190.1 	"
        />
      </g>
      <g>
        <linearGradient
          id="SVGID_19_"
          gradientUnits="userSpaceOnUse"
          x1="213.4783"
          y1="197.4304"
          x2="213.4783"
          y2="98.4989"
        >
          <stop
            offset={0}
            style={{ stopColor: "#4FC3F6", stopOpacity: 0.25 }}
          />
          <stop offset={1} style={{ stopColor: "#111C2C", stopOpacity: 0 }} />
        </linearGradient>
        <polygon
          className="st26"
          points="240.6,190.1 186.2,197.4 186.3,113.5 240.7,98.5 	"
        />
      </g>
      <g>
        <linearGradient
          id="SVGID_20_"
          gradientUnits="userSpaceOnUse"
          x1="271.4808"
          y1="197.9415"
          x2="271.4808"
          y2="98.4989"
        >
          <stop offset={0} style={{ stopColor: "#4FC3F6" }} />
          <stop
            offset="0.75"
            style={{ stopColor: "#111C2C", stopOpacity: 0 }}
          />
          <stop
            offset={1}
            style={{ stopColor: "#4FC3F6", stopOpacity: "0.5" }}
          />
        </linearGradient>
        <polygon
          className="st27"
          points="302.3,114 302.2,197.9 240.6,190.1 240.7,98.5 	"
        />
      </g>
    </motion.g>
  )
}
